import { useState } from 'react';
import useFadeUp from '../hooks/useFadeUp';

import img1  from '../assets/20240320_170457~2.jpg';
import img2  from '../assets/DSC03284-EDIT.jpg';
import img3  from '../assets/20200303_210124.jpg';
import img4  from '../assets/20200303_134919.jpg';
import img5  from '../assets/20191107_152616.jpg';
import img6  from '../assets/20191106_112036.jpg';
import img7  from '../assets/20191105_134054.jpg';
import img8  from '../assets/20191111_231329.jpg';
import img9  from '../assets/20191104_184302.jpg';
import img10 from '../assets/20191104_190311.jpg';
import img11 from '../assets/IMG_20190716_143449.jpg';
import img12 from '../assets/20220530_135119.jpg';
import img13 from '../assets/20240318_112020~2.jpg';
import img14 from '../assets/PXL_20240319_101451967 (1).jpg';
import logo  from '../assets/megedLogoTransp.png';
import img15 from '../assets/IMG_20230102_202107.jpg';
import img16 from '../assets/20140210_143819-EDIT.jpg';
import img17 from '../assets/20220531_075447.jpg';
import img18 from '../assets/20220530_130615~2-EDIT.jpg';

const photos = [
  { src: img1,  location: 'איטליה 🇮🇹',    likes: 847, caption: 'רחובות בלאגיו - כשאיטליה פשוט גונבת לך את הלב ❤️' },
  { src: img2,  location: 'לונדון 🇬🇧',     likes: 623, caption: 'Tower Bridge בשקיעה - לונדון תמיד מפתיעה 🌅' },
  { src: img3,  location: 'ברלין 🇩🇪',      likes: 512, caption: 'שער ברנדנבורג - היסטוריה שאפשר לגעת בה ✋' },
  { src: img4,  location: 'ברלין 🇩🇪',      likes: 438, caption: 'הרייכסטאג - ארכיטקטורה שמספרת סיפור 🏛️' },
  { src: img5,  location: 'הולנד 🇳🇱',      likes: 731, caption: 'סתיו אמסטרדמי - עלים, אופניים ושלווה 🍂' },
  { src: img6,  location: 'הולנד 🇳🇱',      likes: 892, caption: 'כפר הולנדי - כשהזמן עוצר לרגע 🐄' },
  { src: img7,  location: 'הולנד 🇳🇱',      likes: 654, caption: 'חיטהורן - ונציה של הולנד, ללא מכוניות 🚣' },
  { src: img8,  location: 'אמסטרדם 🇳🇱',   likes: 978, caption: 'זאנסה סכנס - טחנות הרוח האייקוניות 🌬️' },
  { src: img9,  location: 'אמסטרדם 🇳🇱',   likes: 543, caption: 'תעלות אמסטרדם - קסם שלא נגמר 🌉' },
  { src: img10, location: 'אמסטרדם 🇳🇱',   likes: 1204, caption: 'אמסטרדם בלילה - העיר שלא ישנה ✨' },
  { src: img11, location: 'פירנצה 🇮🇹',    likes: 867, caption: 'פונטה וקיו - גשר שעמד 700 שנה 🌊' },
  { src: img12, location: 'דולומיטים 🏔️',  likes: 1432, caption: 'לאגו די בראיס - ירוק שלא ייאמן 🚣' },
  { src: img13, location: 'לוגאנו 🇨🇭',    likes: 765, caption: 'אגם לוגאנו - שוויץ מהחלום 💙' },
  { src: img14, location: 'לוגאנו 🇨🇭',    likes: 934, caption: 'פריחה מעל האגם - רגע שלא ישכח 🌸' },
  { src: img15, location: 'ברצלונה 🇪🇸', likes: 1087, caption: 'קאסה בטיו של גאודי - אמנות שהפכה לבניין 🎨' },
{ src: img16, location: 'פראג 🇨🇿',    likes: 743,  caption: 'השעון האסטרונומי - 600 שנה של דיוק מושלם ⏰' },
{ src: img17, location: 'Nals, איטליה 🇮🇹', likes: 689, caption: 'נאלס - עיירה ציורית בלב כרמי דרום טירול 🍇' },
{ src: img18, location: 'דולומיטים 🏔️',    likes: 1563, caption: 'לאגו די בראיס - הנוף שגרם לנו לעצור ולנשום 🚣' },
];

function InstagramPost({ photo, delay }) {
  const ref = useFadeUp(delay);
  const [liked, setLiked] = useState(false);
  const [likes, setLikes] = useState(photo.likes);
  const [active, setActive] = useState(false);

  const handleLike = () => {
    setLiked(!liked);
    setLikes(liked ? likes - 1 : likes + 1);
  };

  return (
    <div ref={ref} className="bg-white rounded-2xl overflow-hidden shadow-card border border-gray-100">

      {/* Header */}
      <div className="flex items-center gap-3 px-4 py-3">
        <div className="w-9 h-9 rounded-full bg-brand-beige border-2 border-brand-blue/20
                        flex items-center justify-center overflow-hidden flex-shrink-0">
          <img src={logo} alt="מגד שמיים" className="w-full h-full object-contain mix-blend-multiply" />
        </div>
        <div>
          <div className="font-body font-semibold text-[13px] text-gray-900">meged_shamaim</div>
          <div className="font-body text-[11px] text-gray-400 font-light">{photo.location}</div>
        </div>
        <div className="mr-auto">
          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <circle cx="12" cy="5" r="1" fill="currentColor"/>
            <circle cx="12" cy="12" r="1" fill="currentColor"/>
            <circle cx="12" cy="19" r="1" fill="currentColor"/>
          </svg>
        </div>
      </div>

      {/* Image */}
      <div className="relative aspect-square overflow-hidden cursor-pointer"
           onClick={() => setActive(!active)}>
        <img src={photo.src} alt={photo.location}
             className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" />
      </div>

      {/* Actions */}
      <div className="px-4 pt-3 pb-1">
        <div className="flex items-center gap-4 mb-2">
          <button onClick={handleLike} className="transition-transform active:scale-125 duration-150">
            {liked ? (
              <svg className="w-6 h-6 text-red-500" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
              </svg>
            ) : (
              <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
              </svg>
            )}
          </button>
          <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
          <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/>
          </svg>
          <svg className="w-6 h-6 text-gray-700 mr-auto" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>
          </svg>
        </div>

        {/* Likes */}
        <div className="font-body font-semibold text-[13px] text-gray-900 mb-1">
          {likes.toLocaleString()} לייקים
        </div>

        {/* Caption */}
        <p className="font-body text-[13px] text-gray-700 leading-relaxed pb-3">
          <span className="font-semibold">maged_shamayim </span>
          {photo.caption}
        </p>
      </div>
    </div>
  );
}

export default function Gallery() {
  const headerRef = useFadeUp(0);

  return (
    <section id="gallery" className="py-24 px-6 bg-white">
      <div className="max-w-6xl mx-auto">

        <div ref={headerRef} className="text-center mb-12">
          <span className="inline-block bg-brand-blue-light text-brand-blue
                           text-[11px] font-bold tracking-[2px] uppercase
                           px-4 py-1.5 rounded-full mb-3">
            גלריה
          </span>
          <h2 className="font-display font-bold text-[clamp(1.8rem,3vw,2.6rem)]
                         leading-tight tracking-tight text-gray-900 mb-3">
            תמונות מהמטיילים שלנו...
          </h2>
          <p className="font-body font-light text-gray-500 text-[1.05rem]">
            רגעים אמיתיים מהשטח - צולמו על ידי הצוות והמטיילים שלנו
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {photos.map((photo, i) => (
            <InstagramPost key={i} photo={photo} delay={i % 3 * 100} />
          ))}
        </div>

      </div>
    </section>
  );
}